import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Checkbox} from 'semantic-ui-react';

import EmailSelect from './EmailSelect';

const ReceiptForm = props => {
  const [sendReceipt, setSendReceipt] = useState(props.forceOpen);

  useEffect(() => {
    if (props.forceOpen) {
      setSendReceipt(true);
    }
  }, []);

  const handleSendReceiptChange = (e, {checked}) => {
    setSendReceipt(checked);

    if (!checked) {
      props.updateReceipts([], false);
    }
  };

  return (
    <>
      <div style={props.checkboxContainerStyle}>
        <Checkbox
          checked={sendReceipt}
          label={props.checkboxLabel}
          onChange={handleSendReceiptChange}
        />
      </div>

      {sendReceipt ? (
        <EmailSelect
          customerId={props.customerId}
          receiptEmails={props.receiptEmails}
          skipLoad={props.guestAccess}
          ticketId={props.ticketId}
          update={value => props.updateReceipts(value, sendReceipt)}
          value={props.value}
        />
      ) : null}
    </>
  );
};

ReceiptForm.defaultProps = {
  checkboxContainerStyle: {},
  checkboxLabel: 'Send Receipt',
  forceOpen: false,
  guestAccess: false,
  receiptEmails: [],
  ticketId: null,
  value: [],
};

ReceiptForm.propTypes = {
  checkboxContainerStyle: PropTypes.object,
  checkboxLabel: PropTypes.string,
  customerId: PropTypes.number.isRequired,
  forceOpen: PropTypes.bool,
  guestAccess: PropTypes.bool,
  receiptEmails: PropTypes.array,
  ticketId: PropTypes.number,
  value: PropTypes.array,

  // functions
  updateReceipts: PropTypes.func.isRequired,
};

export default ReceiptForm;



// WEBPACK FOOTER //
// ./src/components/Common/Form/ReceiptForm.js